
/**
* @Author: amywulan
* @Date: 2020-09-08 12:00:00
*/
import newCouponBannerBr from '@/assets/images/banner/new_coupon_banner_br@2x.png'
import newCouponBannerMx from '@/assets/images/banner/new_coupon_banner_mx@2x.png'
import newCouponBannerJp from '@/assets/images/banner/new_coupon_banner_jp@2x.png'
import paySuccess from '@/assets/images/c/pay-success.gif'
import payIng from '@/assets/images/c/pay-ing.gif'
import payError from '@/assets/images/c/pay-error.gif'
import i18n from '@/common/js/i18n'

export const BANNER_MAP = {
  // 巴西banner
  BR: {
    skinUrl: newCouponBannerBr,
    backgroundColor: '#F29B12'
  },
  // 墨西哥banner
  MX: {
    skinUrl: newCouponBannerMx,
    backgroundColor: '#FF7A45'
  },
  // 日本banner
  JP: {
    skinUrl: newCouponBannerJp,
    backgroundColor: '#FF7A45'
  }
}

export const PAY_LIST = [
  // 支付中
  {
    payStatus: 1,
    imgUrl: payIng,
    title: i18n._('支付中'),
    text: i18n._('等待支付结果')
  },
  // 支付成功
  {
    payStatus: 2,
    imgUrl: paySuccess,
    title: i18n._('支付成功')
  },
  // 支付失败
  {
    payStatus: 3,
    imgUrl: payError,
    title: i18n._('支付超时！')
  }
]

// 端bridge控制状态栏标题栏的配置
export function navConfig (pageTitle) {
  return {
    sysStatusBar: 1, // 0黑色,1白色
    backBtn: { // 返回按钮
      alpha: 1, // 透明度
      color: '#FFFFFF' // 字体颜色
    },
    title: {
      color: '#000000',
      alpha: 0,
      content: pageTitle
    },
    nav: { // titlebar背景条
      color: '#FFFFFF',
      alpha: 0
    },
    rightBtns: [ // titlebar右边按钮
      {
        name: 'shareBtn',
        alpha: 0,
        currentIcon: '', // 实际图
        preloadIcon: '', // 预加载图
        action: 'triggerShareButtonEvent'
      }
    ]
  }
}
// Percent<=0
export function confConfigPercent0 (pageTitle) {
  return {
    sysStatusBar: 1,
    backBtn: {
      alpha: 1,
      color: '#FFFFFF'
    },
    title: {
      color: '#000000',
      alpha: 0,
      content: pageTitle
    },
    nav: {
      color: '#FFFFFF',
      alpha: 0
    },
    rightBtns: [ // titlebar右边按钮
      {
        name: 'shareBtn',
        alpha: 0,
        currentIcon: '', // 实际图
        preloadIcon: '', // 预加载图
        action: 'triggerShareButtonEvent'
      }
    ]
  }
}

// Percent<=1
export function confConfigPercent1 (percent, pageTitle) {
  return {
    sysStatusBar: 0,
    backBtn: {
      alpha: percent,
      color: '#FFFFFF'
    },
    title: {
      color: '#000000',
      alpha: percent,
      content: pageTitle
    },
    nav: {
      color: '#FFFFFF',
      alpha: percent
    },
    rightBtns: [ // titlebar右边按钮
      {
        name: 'shareBtn',
        alpha: 0,
        currentIcon: '', // 实际图
        preloadIcon: '', // 预加载图
        action: 'triggerShareButtonEvent'
      }
    ]
  }
}

// alpha<1
export function confConfigalpha1 (pageTitle) {
  return {
    sysStatusBar: 0,
    backBtn: {
      alpha: 1,
      color: '#000000'
    },
    title: {
      color: '#000000',
      alpha: 1,
      content: pageTitle
    },
    nav: {
      color: '#FFFFFF',
      alpha: 1
    },
    rightBtns: [ // titlebar右边按钮
      {
        name: 'shareBtn',
        alpha: 0,
        currentIcon: '', // 实际图
        preloadIcon: '', // 预加载图
        action: 'triggerShareButtonEvent'
      }
    ]
  }
}
